"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _underscore = _interopRequireDefault(require("underscore"));

var _index = require("./form-text-field/index");

var _KeyboardUtils = _interopRequireDefault(require("../../util/KeyboardUtils.js"));

var _classnames = _interopRequireDefault(require("classnames"));

var _InputWidths = require("../forms/InputWidths");

var _StateContainer = require("../utils/StateContainer");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source))).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
* @callback FormSearchBox~onValueChange
*
* @param {string} queryString
*     The new query string
*/

/**
* @callback FormSearchBox~onKeyDown
*
* @param {object} e
*    The ReactJS synthetic event object.
*/

/**
* @callback FormSearchBox~onFocus
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormSearchBox~onBlur
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormSearchBox~onClear
*/

/**
* @class FormSearchBox
* @desc A search input box which calls the provided callback function on change.
*     Will also clear query string on ESC or (X) button click.
*
* @param {string} [data-id="searchBox"]
*     To define the base "data-id" value for top-level HTML container
* @param {string} [className]
*     CSS classes to set on the top-level HTML container
*
* @param {string} [queryString]
*     Query string to be used as value in the search field
* @param {string} [value]
*     Alias for queryString
* @param {string} [message]
*    The message text to display.
* @param {string} [messageType=error]
*    The type of message (error = red, info = blue, success = green, warning = yellow).
* @param {string} [placeholder]
*     Hint text inside searchBox
* @param {string} [name]
*    Name attribute for the input.
* @param {boolean} [noSpacing=false]
*     When true, the default margin is removed.
* @param {InputWidths} [width]
*    Specifies the width of the input.
* @param {FormSearchBox~onValueChange} onValueChange
*     Callback to be triggered when the searchbox value changes
*
* @param {FormSearchBox~onKeyDown} [onKeyDown]
*     Callback to be triggered when a key is pressed down in the search box.
*     "ESC" key clears the search field by default.
* @param {FormSearchBox~onFocus} [onFocus]
*     Callback to be triggered when the search box gains focus.
* @param {FormSearchBox~onBlur} [onBlur]
*     Callback to be triggered when the search box blurs (loses focus).
* @param {FormSearchBox~onClear} [onClear]
*     Callback to be triggered when the search field is cleared.
* @param {number} [maxLength]
*     Maximum length supported by the text field.
* @param {boolean} [autoFocus=false]
*     Whether or not to auto-focus the element.
*
* @example
*     <FormSearchBox data-id="mySearchBox"
*         queryString="keyword to search"
*         placeholder="Search"
*         onChange={this._filterOptions} />
*/
var searchBoxProgressiveState = (0, _StateContainer.createProgressiveState)([{
  name: "queryString",
  initial: "",
  setter: "onValueChange"
}]);

var FormSearchBox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormSearchBox, _React$Component);

  var _super = _createSuper(FormSearchBox);

  function FormSearchBox(props) {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FormSearchBox);
    _this = _super.call(this, props);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_search", function (value) {
      _this.callbacks.onValueChange(value);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_clear", function () {
      _this._search("");

      _this.props.onClear();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleSearchBoxKeyDown", function (e) {
      if (e.keyCode === _KeyboardUtils.default.KeyCodes.ESC) {
        _this._clear();
      }

      _this.props.onKeyDown(e);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getSearchInputRef", function () {
      return _this.refs.searchBox.refs["searchBox-input"];
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "searchBoxFocus", function () {
      _this._getSearchInputRef().focus();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "isFocused", function () {
      return document.activeElement === _this._getSearchInputRef();
    });
    var queryString = props.queryString,
        _value = props.value,
        onValueChange = props.onValueChange;
    var passedProps = {
      queryString: queryString !== undefined ? queryString : _value,
      onValueChange: onValueChange
    };

    var _searchBoxProgressive = searchBoxProgressiveState({
      initialState: props.initialState,
      passedProps: passedProps,
      boundSetState: (0, _bind.default)(_context = _this.setState).call(_context, (0, _assertThisInitialized2.default)(_this))
    }),
        _searchBoxProgressive2 = (0, _slicedToArray2.default)(_searchBoxProgressive, 2),
        state = _searchBoxProgressive2[0],
        callbacks = _searchBoxProgressive2[1];

    _this.state = state;
    _this.callbacks = _objectSpread({
      onValueChange: onValueChange
    }, callbacks);
    return _this;
  }
  /**
   * @desc Search when the searchBox has a new value.
   * @param {object} value
   *     The query string value.
   * @private
   * @ignore
   */


  (0, _createClass2.default)(FormSearchBox, [{
    key: "render",
    value: function render() {
      var value = this.state && this.state.queryString || this.props.queryString || this.props.value || "";
      var showClear = value !== "";
      var iconClasses = (0, _classnames.default)("input-icon", "icon-" + this.props.iconName);
      var inputClasses = (0, _classnames.default)("search", {
        "input-text--mono": this.props.monospaced
      });
      var autoFocus = this.props.autoFocus;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: this.props.className
      }, /*#__PURE__*/_react.default.createElement(_index.FormTextFieldStateless, {
        "data-id": "searchBox",
        ref: "searchBox",
        className: inputClasses,
        message: this.props.errorMessage || this.props.message,
        messageType: this.props.messageType,
        value: value,
        placeholder: this.props.placeholder,
        name: this.props.name,
        noSpacing: this.props.noSpacing,
        onValueChange: this._search,
        onKeyDown: this._handleSearchBoxKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        maxLength: this.props.maxLength,
        autoFocus: autoFocus,
        controls: showClear ? /*#__PURE__*/_react.default.createElement("a", {
          "data-id": "clear",
          className: "clear-search",
          onClick: this._clear
        }) : null,
        width: this.props.width
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: iconClasses
      })));
    }
  }]);
  return FormSearchBox;
}(_react.default.Component);

(0, _defineProperty3.default)(FormSearchBox, "displayName", "FormSearchBox");
(0, _defineProperty3.default)(FormSearchBox, "messageTypes", _index.messageTypes);
(0, _defineProperty3.default)(FormSearchBox, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  errorMessage: _propTypes.default.node,
  iconName: _propTypes.default.string,
  inputFieldClassName: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  message: _propTypes.default.string,
  messageType: _propTypes.default.string,
  name: _propTypes.default.string,
  noSpacing: _propTypes.default.bool,
  onValueChange: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onClear: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  queryString: _propTypes.default.string,
  width: _propTypes.default.oneOf(_InputWidths.InputWidthProptypesAuto),
  autoFocus: _propTypes.default.bool,
  initialState: _propTypes.default.object
});
(0, _defineProperty3.default)(FormSearchBox, "defaultProps", {
  "data-id": "FormSearchBox",
  iconName: "search",
  noSpacing: false,
  onKeyDown: _underscore.default.noop,
  onFocus: _underscore.default.noop,
  onBlur: _underscore.default.noop,
  onClear: _underscore.default.noop,
  onValueChange: _underscore.default.noop,
  errorMessage: null,
  width: _InputWidths.InputWidths.MD,
  autoFocus: false,
  initialState: {}
});
(0, _defineProperty3.default)(FormSearchBox, "inputWidths", _InputWidths.InputWidths);
var _default = FormSearchBox;
exports.default = _default;
module.exports = exports["default"];